import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CombosList from '../components/CombosList';

const CombosPage = () => {
  const { category } = useParams();
  return (
    <div className="App">
      <Header />
      <main>
        <CombosList category={category} />
      </main>
      <Footer />
    </div>
  );
};

export default CombosPage;

